// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YcKi","input":"styles_input__2ERjg"};